module.exports = __webpack_public_path__ + "static/media/cannabis-gray.86122671.svg";